import { render, staticRenderFns } from "./shfx1.vue?vue&type=template&id=7097720a&scoped=true"
import script from "./shfx1.vue?vue&type=script&lang=js"
export * from "./shfx1.vue?vue&type=script&lang=js"
import style0 from "./shfx1.vue?vue&type=style&index=0&id=7097720a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7097720a",
  null
  
)

export default component.exports